import TrainerStatsTable from './TrainerStatsTable.jsx';

export default TrainerStatsTable;
